import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GA4ConfigService {
  private globalPropertyId = '';
  private activeMinisiteProperty: string | null = null;
  private isInMinisite = false;

  constructor() { }

  configGlobalProperty(propertyId: string) {
    this.globalPropertyId = propertyId;
    // CONFIGURAZIONE PROPERTY GLOBALE
    gtag('config', propertyId, {
      debug_mode: true,
      'groups': 'dottnet_global', // Gruppo dedicato per la property globale
      'send_page_view': true,
      'custom_map': {
        'site_section': 'global'
      }
    });

    console.log('GoogleAnalytics script injected');
  }

  /**
   * Attiva il tracking del minisito SENZA configurare la property
   */
  activateMinisiteTracking(propertyId: string, minisiteData: any) {
    this.activeMinisiteProperty = propertyId;
    this.isInMinisite = true;

    console.log(`Minisite tracking activated (NO CONFIG): ${propertyId}`);

    // NON chiamare gtag('config') per la property minisito!
    // Invieremo gli eventi direttamente specificando send_to

    // Invia il page_view iniziale
    this.trackPageView(minisiteData.permalink, minisiteData.titolo);
  }

  /**
   * Disattiva il tracking del minisito
   */
  deactivateMinisiteTracking() {
    if (this.activeMinisiteProperty) {
      console.log(`Minisite tracking deactivated: ${this.activeMinisiteProperty}`);
      this.activeMinisiteProperty = null;
      this.isInMinisite = false;
    }
  }

  /**
   * Traccia page_view: sempre alla globale, + minisito se attivo (senza config)
   */
  trackPageView(pagePath: string, pageTitle?: string, additionalParams: any = {}) {
    const baseParams = {
      'page_path': pagePath,
      'page_title': pageTitle,
      'page_location': window.location.href,
      ...additionalParams
    };

    // SEMPRE invia alla property globale
    // gtag('event', 'page_view', {
    //   ...baseParams,
    //   'send_to': this.globalPropertyId
    // });

    // console.log(`Global page_view sent to ${this.globalPropertyId}:`, pagePath);

    // SE siamo in un minisito, invia ANCHE alla property minisito SENZA averla configurata
    if (this.isInMinisite && this.activeMinisiteProperty) {
      gtag('event', 'page_view', {
        ...baseParams,
        'send_to': this.activeMinisiteProperty
      });

      console.log(`Minisite page_view sent (NO CONFIG) to ${this.activeMinisiteProperty}:`, pagePath);
    }
  }

  /**
   * Traccia eventi: sempre alla globale, + minisito se attivo (senza config)
   */
  trackEvent(eventName: string, parameters: any = {}) {
    // SEMPRE invia alla property globale
    gtag('event', eventName, {
      ...parameters,
      'send_to': this.globalPropertyId
    });

    console.log(`Global ${eventName} sent to ${this.globalPropertyId}:`, parameters);

    // SE siamo in un minisito, invia ANCHE alla property minisito SENZA averla configurata
    if (this.isInMinisite && this.activeMinisiteProperty) {
      gtag('event', eventName, {
        ...parameters,
        'send_to': this.activeMinisiteProperty
      });

      console.log(`Minisite ${eventName} sent (NO CONFIG) to ${this.activeMinisiteProperty}:`, parameters);
    }
  }

  isMinisiteTrackingActive(): boolean {
    return this.isInMinisite && !!this.activeMinisiteProperty;
  }

  getActiveMinisiteProperty(): string | null {
    return this.activeMinisiteProperty;
  }
}
